import * as actionTypes from './actionTypes';

export const setSentenceList = (data) => ({
  type: actionTypes.SET_SENTENCE_LIST,
  data
});